<header>
    <dx-toolbar class="header-toolbar">
        @if (menuToggleEnabled) {
            <dxi-item
                location="before"
                widget="dxButton"
                cssClass="menu-button"
                [options]="{
                    icon: 'menu',
                    stylingMode: 'text',
                    onClick: toggleMenu
                }"
            >
            </dxi-item>
        }
        @if (title) {
            <dxi-item
                location="before"
                cssClass="header-title"
            >
                <app-logo></app-logo>
            </dxi-item>
        }

        <dxi-item
            location="after"
            widget="dxTextBox"
            locateInMenu="auto"
            cssClass="global-search-box"
            [options]="{
                stylingMode: 'filled',
                mode: 'search',
                placeholder: 'Search',
                width: 180
            }"
        >
        </dxi-item>

        <dxi-item location="after" locateInMenu="never">
            <theme-switcher></theme-switcher>
        </dxi-item>

        <dxi-item location="after">
            <div class="messages">
                <dx-button
                    icon="belloutline"
                    stylingMode="text"
                >
                </dx-button>
            </div>
        </dxi-item>

        @if (isImpersonated) {
            <dxi-item location="after">
                <dx-button
                    icon="undo"
                    text="Undo Impersonate"
                    type="danger"
                    stylingMode="contained"
                    (onClick)="undoImpersonate()"
                >
                </dx-button>
            </dxi-item>
        }

        <dxi-item location="after" locateInMenu="auto" menuItemTemplate="menuItem">
            <div *dxTemplate="let data of 'item'">
                <user-panel
                    [user]="user"
                    [menuItems]="userMenuItems"
                    menuMode="context"
                ></user-panel>
            </div>
        </dxi-item>
        <div *dxTemplate="let data of 'menuItem'">
            <user-panel
                [user]="user"
                [menuItems]="userMenuItems"
                menuMode="list"
            ></user-panel>
        </div>
    </dx-toolbar>
</header>
